// JS-side copy of --color-accent (light value) for places that need a real
// hex string (AvatarView appends an alpha suffix; a var() can't take one).
// Keep in sync with docs/product/DESIGN_TOKENS.md.
export const DEFAULT_ACCENT_HEX = '#17b79b';
